<template>
    <div v-loading="loading">
        <zm-row v-if="hasPermission">
            <!-- <zm-button size="small" @click="fetchData()" type="primary" class="btn-in-line" plain>show all</zm-button> -->
            <zm-button size="small" @click="showDelete()" type="danger" class="btn-in-line" plain v-if="ids.length">delete</zm-button>
            <zm-button size="small" @click="showUpdate()" type="primary" class="btn-in-line" plain v-if="ids.length">batch edit</zm-button>
        </zm-row>
        <zm-form inline>
            <zm-form-item label="id">
                <div slot="label">
                    <tip label="id" id="clientMap-id"></tip>
                </div>
                <zm-input size="small" placeholder="id" v-model.trim="params.id" @keyup.enter.native="fetchData()" style="width:120px"></zm-input>
            </zm-form-item>
            <zm-form-item label="requestIp">
                <div slot="label">
                    <tip label="requestIp" id="clientMap-requestIp"></tip>
                </div>
                <zm-input size="small" placeholder="requestIp" v-model.trim="params.requestIp" @keyup.enter.native="fetchData()" style="width:120px"></zm-input>
            </zm-form-item>
            <zm-form-item label="ip">
                <div slot="label">
                    <tip label="ip" id="clientMap-ip"></tip>
                </div>
                <zm-input size="small" placeholder="ip" v-model.trim="params.ip" @keyup.enter.native="fetchData()" style="width:120px"></zm-input>
            </zm-form-item>
            <zm-form-item label="clientName">
                <div slot="label">
                    <tip label="clientName" id="clientMap-clientName"></tip>
                </div>
                <zm-input size="small" placeholder="clientName" v-model.trim="params.clientName" @keyup.enter.native="fetchData()" style="width:120px"></zm-input>
            </zm-form-item>
            <zm-form-item label="hostName">
                <div slot="label">
                    <tip label="hostName" id="clientMap-hostName"></tip>
                </div>
                <zm-input size="small" placeholder="hostName" v-model.trim="params.hostName" @keyup.enter.native="fetchData()" style="width:120px"></zm-input>
            </zm-form-item>
            <zm-button type="icon" size="small" icon="zm-icon-search" @click="fetchData()"></zm-button>
        </zm-form>
        <zm-table :data="list" border @sort-change="onSort" @selection-change="handleSelectionChange"
        :init-displayed-column="initDisplayedColumn" @expand-change="expandHandler">
            <zm-table-column prop="selection" type="selection" width="55" v-if="hasPermission"></zm-table-column>
            <zm-table-column prop="expand" type="expand">
                <template slot-scope="scope">
                    <zm-form v-loading="scope.row.loading">
                        <zm-form-item label="settingCreatedTime">{{ setTime('', '', scope.row.settingCreatedTime) }}</zm-form-item>
                        <zm-form-item label="settingModifiedTime">{{ setTime('', '', scope.row.settingModifiedTime) }}</zm-form-item>
                    </zm-form>
                    <zm-table v-if="scope.row.workingConsumers" :data="scope.row.workingConsumers" v-loading="scope.row.loading">
                        <zm-table-column label="workingConsumers" align="center">
                            <zm-table-column label="topic" prop="topic"></zm-table-column>
                            <zm-table-column label="group" prop="group"></zm-table-column>
                        </zm-table-column>
                    </zm-table>
                    <zm-table v-if="scope.row.settingConsoleStartConsumers" style="margin-top: 10px;"
                    :data="scope.row.settingConsoleStartConsumers" v-loading="scope.row.loading">
                        <zm-table-column label="settingConsoleStartConsumers" align="center">
                            <zm-table-column label="topic" prop="topic"></zm-table-column>
                            <zm-table-column label="group" prop="group"></zm-table-column>
                            <zm-table-column label="consumeDelayMs" prop="consumeDelayMs"></zm-table-column>
                            <zm-table-column label="counts" prop="counts"></zm-table-column>
                            <zm-table-column label="receiveCounts" prop="receiveCounts"></zm-table-column>
                            <zm-table-column prop="acceptDistribute" label="acceptDistribute">
                                <template slot-scope="scope">
                                    <i :class="scope.row.acceptDistribute ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                                </template>
                            </zm-table-column>
                        </zm-table-column>
                    </zm-table>
                </template>
            </zm-table-column>
            <zm-table-column prop="id" label="id"></zm-table-column>
            <zm-table-column prop="requestIp" label="requestIp"></zm-table-column>
            <zm-table-column prop="ip" label="ip"></zm-table-column>
            <zm-table-column prop="clientName" label="clientName"></zm-table-column>
            <zm-table-column prop="hostName" label="hostName"></zm-table-column>
            <zm-table-column prop="globalHandlers" label="globalHandlers">
                <template slot-scope="scope">
                    <zm-tooltip placement="right"
                    v-if="scope.row.globalHandlers && scope.row.globalHandlers.length">
                        <div slot="content">
                            <p v-for="item in scope.row.globalHandlers" :key="item">{{ item }}</p>
                        </div>
                        <zm-tag size="medium" type="">show</zm-tag>
                    </zm-tooltip>
                    <span v-else></span>
                </template>
            </zm-table-column>
            <zm-table-column prop="createdTime" label="createdTime" :formatter="setTime"></zm-table-column>
            <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime"></zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination @current-change="fetchData"
             @size-change="handleSizeChange"
                :current-page.sync="params.page" :page-size="params.size"
                :page-sizes="[10, 20, 50, 100, 500, 1000]"
                layout="total, prev, pager, next, sizes"
                :total="total">
            </zm-pagination>
        </div>
        <zm-dialog title="Batch Edit Client Map" :visible.sync="form.visible" width="80%">
            <zm-form :model="form" ref="form" :rules="rules">
                <zm-form-item label="type" prop="type">
                    <div slot="label">
                        <tip label="type" id="clientMap-type"></tip>
                    </div>
                    <zm-radio-group v-model="form.type">
                        <zm-radio label="add"></zm-radio>
                        <zm-radio label="remove"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item v-if="form.type === 'add'">
                    <zm-checkbox v-model="form.isOverwriteAdd">
                        <tip label="isOverwriteAdd" id="clientMap-isOverwriteAdd"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <zm-button type="primary" icon="zm-icon-add" @click="showCreateConsumer()" plain>add consumer</zm-button>
            <zm-table :data="form.settingConsoleStartConsumers">
                <zm-table-column prop="topic" label="topic"></zm-table-column>
                <zm-table-column prop="group" label="group"></zm-table-column>
                <zm-table-column prop="consumeDelayMs" label="consumeDelayMs"></zm-table-column>
                <zm-table-column prop="counts" label="counts"></zm-table-column>
                <zm-table-column prop="receiveCounts" label="receiveCounts"></zm-table-column>
                <zm-table-column prop="acceptDistribute" label="acceptDistribute">
                    <template slot-scope="scope">
                        <i :class="scope.row.acceptDistribute ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                    </template>
                </zm-table-column>
                <zm-table-column width="110px">
                    <template slot-scope="scope">
                        <zm-button type="icon" icon="zm-icon-edit" @click="showEditConsumer(scope.row)"></zm-button>
                        <zm-button type="icon" icon="zm-icon-delete" @click="deleteConsumer(scope.row)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div slot="footer">
                <zm-button size="small" @click="form.visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="updateClientMaps" :loading="form.loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Setting Console Start Consumers" :visible.sync="innerVisible">
            <zm-form :model="consumerForm" ref="consumerForm" :rules="consumerRules" label-width="180px">
                <zm-form-item prop="topic">
                    <div slot="label">
                        <tip label="topic" id="clientMap-consumer-topic"></tip>
                    </div>
                    <zm-select size="small" v-model="consumerForm.topic" filterable placeholder="topic" style="width: 100%">
                        <zm-option v-for="item in topicList" :key="item.id" :value="item.name" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="group">
                    <div slot="label">
                        <tip label="group" id="clientMap-consumer-group"></tip>
                    </div>
                    <zm-input v-model.trim="consumerForm.group" :disabled="!consumerForm.isCreate"></zm-input>
                </zm-form-item>
                <zm-form-item>
                    <div slot="label">
                        <tip label="counts" id="clientMap-consumer-counts"></tip>
                    </div>
                    <zm-input-number v-model="consumerForm.counts" :min="1"></zm-input-number>
                </zm-form-item>
                <zm-form-item>
                    <div slot="label">
                        <tip label="receiveCounts" id="clientMap-consumer-receiveCounts"></tip>
                    </div>
                    <zm-input-number v-model="consumerForm.receiveCounts" :min="1"></zm-input-number>
                </zm-form-item>
                <zm-form-item>
                    <div slot="label">
                        <tip label="consumeDelayMs" id="clientMap-consumer-consumeDelayMs"></tip>
                    </div>
                    <zm-input-number v-model="consumerForm.consumeDelayMs" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="consumerForm.acceptDistribute">
                        <tip label="acceptDistribute" id="clientMap-consumer-acceptDistribute"></tip>
                    </zm-checkbox>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="innerVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveConsumer">Add</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listClientMap, deleteClientMaps, getDetail, updateClientMaps } from '@/api/clientMap'
import { getTopics } from '../../api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'clientMap',
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'clientMap',
                props: ['selection', 'id', 'ip', 'hostName', 'globalHandlers', 'requestIp', 'clientName', 'createdTime', 'modifiedTime']
            },
            list: [],
            topicList: [],
            ids: [],
            form: {
                visible: false,
                loading: false,
                type: '',
                isOverwriteAdd: false,
                settingConsoleStartConsumers: []
            },
            innerVisible: false,
            consumerForm: {
                isCreate: false,
                acceptDistribute: false,
                consumeDelayMs: 0,
                counts: 1,
                receiveCounts: 1,
                group: '',
                topic: ''
            },
            rules: {
                type: [
                    { required: true, message: 'please select type', trigger: 'blur' }
                ]
            },
            consumerRules: {
                topic: [
                    { required: true, message: 'please enter topic', trigger: 'blur' }
                ],
                group: [
                    { required: true, message: 'please enter group', trigger: 'blur' }
                ]
            },
            loading: false,
            params: {
                id: '',
                hostName: '',
                ip: '',
                requestIp: '',
                clientName: '',
                page: 1,
                size: 10
            },
            total: 0
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.params = JSON.parse(localStorage.params).params
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchTopics()
        this.fetchData()
    },
    watch: {
        'params.id' () {
            this.setURL()
        },
        'params.hostName' () {
            this.setURL()
        },
        'params.ip' () {
            this.setURL()
        },
        'params.requestIp' () {
            this.setURL()
        },
        'params.clientName' () {
            this.setURL()
        },
        'params.page' () {
            this.setURL()
        },
        'params.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { params } = this
            const data = { path: this.$route.path, params }
            localStorage.params = JSON.stringify(data)
        },
        fetchData () {
            this.loading = true
            const params = JSON.parse(JSON.stringify(this.params))
            params.page--
            listClientMap(params).then(response => {
                const { content, total } = response
                this.list = content
                this.total = total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        expandHandler (row, expandedRows) {
            expandedRows.forEach(e => {
                if (row.id === e.id) {
                    row.loading = true
                    getDetail(row.id).then(res => {
                        row.loading = false
                        row.workingConsumers = res.workingConsumers
                        row.settingConsoleStartConsumers = res.settingConsoleStartConsumers
                        row.settingCreatedTime = res.settingCreatedTime
                        row.settingModifiedTime = res.settingModifiedTime
                    }).catch(() => {
                        row.loading = false
                    })
                }
            })
        },
        updateClientMaps () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const { type, isOverwriteAdd, settingConsoleStartConsumers } = this.form
                    const isAdd = type === 'add'
                    const isRemove = type === 'remove'
                    const ids = this.ids
                    const data = { ids, isAdd, isRemove, isOverwriteAdd, settingConsoleStartConsumers }
                    this.form.loading = true
                    updateClientMaps(data).then(response => {
                        this.form.visible = false
                        this.form.loading = false
                        this.$message.success('Update success')
                    }).catch(() => {
                        this.form.loading = false
                    })
                }
            })
        },
        saveConsumer () {
            this.$refs.consumerForm.validate((valid) => {
                if (valid) {
                    const { isCreate, acceptDistribute, consumeDelayMs, counts, receiveCounts, group, topic } = this.consumerForm
                    if (isCreate) {
                        const flag = this.form.settingConsoleStartConsumers.filter(item => {
                            return item.topic === this.consumerForm.topic && item.group === this.consumerForm.group
                        }).length === 0
                        if (flag) {
                            const data = { acceptDistribute, consumeDelayMs, counts, receiveCounts, group, topic }
                            this.form.settingConsoleStartConsumers.push(data)
                            this.innerVisible = false
                        } else {
                            this.$message.warning('Duplicated topic and group!')
                        }
                    } else {
                        this.form.settingConsoleStartConsumers.map(item => {
                            if (item.topic === this.consumerForm.topic && item.group === this.consumerForm.group) {
                                item.acceptDistribute = acceptDistribute
                                item.consumeDelayMs = consumeDelayMs
                                item.counts = counts
                                item.receiveCounts = receiveCounts
                            }
                        })
                        this.innerVisible = false
                    }
                }
            })
        },
        deleteConsumer (row) {
            this.$confirm('This will delete the consumer. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.form.settingConsoleStartConsumers.splice(this.form.settingConsoleStartConsumers.indexOf(row), 1)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showUpdate () {
            this.form.type = ''
            this.form.isOverwriteAdd = false
            this.form.settingConsoleStartConsumers = []
            this.form.loading = false
            this.form.visible = true
        },
        showCreateConsumer () {
            this.consumerForm.isCreate = true
            this.consumerForm.topic = ''
            this.consumerForm.group = ''
            this.consumerForm.consumeDelayMs = 0
            this.consumerForm.counts = 1
            this.consumerForm.receiveCounts = 1
            this.consumerForm.acceptDistribute = false
            this.innerVisible = true
        },
        handleSizeChange (val) {
            this.params.size = val
            this.fetchData()
        },
        showEditConsumer (row) {
            this.consumerForm.isCreate = false
            this.consumerForm.topic = row.topic
            this.consumerForm.group = row.group
            this.consumerForm.consumeDelayMs = row.consumeDelayMs
            this.consumerForm.counts = row.counts
            this.consumerForm.receiveCounts = row.receiveCounts
            this.consumerForm.acceptDistribute = row.acceptDistribute
            this.innerVisible = true
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
                if (a[prop] > b[prop]) {
                    return descending ? -1 : 1
                } else if (a[prop] < b[prop]) {
                    return descending ? 1 : -1
                } else {
                    return 0
                }
            })
        },
        showDelete () {
            this.loading = true
            this.$confirm('This will delete the client maps. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteClientMaps(this.ids).then(response => {
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                    this.loading = false
                    this.fetchData()
                }).catch(() => {
                    this.$message({
                        message: 'Delete error!',
                        type: 'error'
                    })
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        handleSelectionChange (val) {
            this.ids = []
            val.map(item => {
                this.ids.push(item.id)
            })
        },
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        fetchTopics () {
            getTopics().then(response => {
                this.topicList = response
            })
        }
    }
}
</script>
